import store from "@/factories/store.factory";

export default [
  {
    path: "/error-no-access",
    component: () => import("@/pages/p-error-no-access")
  },
  {
    path: "/",
    component: () => import("@/pages/welcome")
  },
  {
    path: "/med-type",
    name: "chooseMedType",
    component: () => import("@/pages/p-choose-med-type")
  },
  {
    path: "/:location/:medKeyType",
    name: "medKeyType",
    component: () => import("@/pages/chosen-med-type"),
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch("medKey/getMedKeyType", {
        locationId: to.params.location,
        medKeyType: to.params.medKeyType
      });
      next();
    },
    children: [
      {
        path: "my-pills/:pillId?",
        name: "myPills",
        component: () => import("@/pages/p-my-pills-list"),
        props: true
      },
      {
        path: "add-pill/:searchedMedKeyType?",
        name: "addPill",
        component: () => import("@/pages/p-add-pill"),
        props: true
      },
      {
        path: "check-data",
        name: "checkData",
        component: () => import("@/pages/p-check-data")
      },
      {
        path: "order-submit/:workListId",
        name: "orderSubmit",
        component: () => import("@/pages/order-submit/p-order-submit"),
        props: true
      }
    ]
  }
];
